export const NOTES_OPTIONS = [
  {
    header: "Account",
    key: [
      "Login Help",
      "Application / Account Opening",
      "Documents Needed",
      "Account Management",
      "International",
      "Trade Level / Suitability",
      "Pro / Non-Pro Status",
      "LTA",
      "Beneficiary / TOD",
      "Statements / Confirmations",
      "Account Type Request",
      "Closing Account",
    ],
  },
  {
    header: "Margin",
    key: [
      "Good Faith",
      "Margin Call",
      "Buying Power",
      "Day Trading / PDT",
      "Portfolio Margin",
    ],
  },
  {
    header: "Miscellaneous",
    key: ["Resumes", "Fax", "Fauzia", "Spam", "Internal Email"],
  },

  {
    header: "Technical",
    key: [
      "General Question",
      "Platform Education",
      "Platform Figures",
      "Platform / Website Bug",
      "Technical Help",
      "Feedback / Feature Request",
      "Form Related",
      "Commissions / Fees",
      "Tax / Cost Basis",
      "API",
      "Linux",
      "Spam",
      "Internal Email",
      "Fax",
    ],
  },
  {
    header: "Trade Related",
    key: [
      "Order / Position Help",
      "Commissions / Fees / Rates",
      "Expiration",
      "Exercise / Assignment",
      "Quote",
      "Hard to Borrow",
      "Mobile - Android",
      "Mobile - iOS",
      "Futures",
      "Corporate Actions / Dividend",
      "Earnings",
      "tastytrade",
    ],
  },

  {
    header: "Funding",
    key: [
      "Deposit - ACAT",
      "Deposit - ACH",
      "Deposit - Wire",
      "Deposit - Check",
      "Internal Transfer",
      "Withdrawal - ACAT",
      "Withdrawal - ACH",
      "Withdrawal - Wire",
      "Withdrawal - Check",
      "Funding - General",
      "Wire Reimbursement",
    ],
  },

  {
    header: "IRA",
    key: [
      "IRA - General",
      "IRA Deposit / 401k Rollover",
      "IRA Withdrawal",
      "Roth Conversion",
    ],
  },

  {
    header: "Promotions",
    key: [
      "Small Exchange",
      "Skin in the Game",
      "Bob",
      "Referral",
      "Marketing Partners",
      "Swag",
      "luckbox",
    ],
  },
]

export const NOTES_FILTER_OPTIONS = [
  "Account",
  "Funding",
  "Margin",
  "Trade Related",
  "Technical",
  "IRA",
  "Promotions",
  "Miscellaneous",
  "Tech Support",
  "Trade Desk",
]

export const ALWAYS_EXCLUDED_TYPES = ["Margin and Risk"]
